import React, { useState } from 'react';
import { Download, Plus } from 'lucide-react';
import Sidebar, { useSidebar } from '../../components/ui/Sidebar';
import Button from '../../components/ui/Button';


import TopNavbar from '../../components/ui/TopNavbar';
import Icon from '../../components/AppIcon';


const AccountsPayable = () => {
  const { isCollapsed } = useSidebar();
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [showAddInvoiceModal, setShowAddInvoiceModal] = useState(false);

  // Enhanced Mock AP data with comprehensive coal trading vendors
  const [invoices, setInvoices] = useState([
    {
      id: 'AP-2024-001',
      vendor: 'Global Surveyors Pty Ltd',
      amount: 4500.00,
      currency: 'AUD',
      dueDate: '2025-01-15',
      issueDate: '2024-12-15',
      status: 'pending',
      category: 'Survey & Inspection',
      shipmentRef: 'SHP-2024-125',
      paymentTerms: 'Net 30',
      description: 'Pre-shipment cargo survey and quality verification - Newcastle Port',
      contactPerson: 'James Wilson',
      contactEmail: 'jwilson@globalsurveyors.com.au',
      accountNumber: 'ACC-GS-2024',
      taxAmount: 450.00,
      subtotal: 4050.00
    },
    {
      id: 'AP-2024-002',
      vendor: 'AusLab Testing Services',
      amount: 6200.00,
      currency: 'AUD',
      dueDate: '2025-01-10',
      issueDate: '2024-12-10',
      status: 'overdue',
      category: 'Lab Analysis',
      shipmentRef: 'SHP-2024-118',
      paymentTerms: 'Net 30',
      description: 'Comprehensive coal quality testing - GCV, ash content, moisture analysis',
      contactPerson: 'Dr. Sarah Chen',
      contactEmail: 'schen@auslabservices.com.au',
      accountNumber: 'ACC-AL-2024',
      taxAmount: 620.00,
      subtotal: 5580.00
    },
    {
      id: 'AP-2024-003',
      vendor: 'Maritime Customs Solutions',
      amount: 3800.00,
      currency: 'AUD',
      dueDate: '2025-01-20',
      issueDate: '2024-12-20',
      status: 'pending',
      category: 'Customs Clearance',
      shipmentRef: 'SHP-2024-130',
      paymentTerms: 'Net 30',
      description: 'Export documentation and customs clearance services',
      contactPerson: 'Michael Thompson',
      contactEmail: 'mthompson@maritimecustoms.com.au',
      accountNumber: 'ACC-MC-2024',
      taxAmount: 380.00,
      subtotal: 3420.00
    },
    {
      id: 'AP-2024-004',
      vendor: 'Pacific Freight Logistics',
      amount: 12500.00,
      currency: 'AUD',
      dueDate: '2024-12-28',
      issueDate: '2024-11-28',
      status: 'paid',
      category: 'Freight & Logistics',
      shipmentRef: 'SHP-2024-112',
      paymentTerms: 'Net 30',
      description: 'Inland transportation from mine to port - 75,000 MT',
      paidDate: '2024-12-27',
      paidAmount: 12500.00,
      contactPerson: 'Robert Lee',
      contactEmail: 'rlee@pacificfreight.com.au',
      accountNumber: 'ACC-PF-2024',
      taxAmount: 1250.00,
      subtotal: 11250.00
    },
    {
      id: 'AP-2024-005',
      vendor: 'Newcastle Port Authority',
      amount: 28000.00,
      currency: 'AUD',
      dueDate: '2025-01-18',
      issueDate: '2024-12-18',
      status: 'pending',
      category: 'Port Charges',
      shipmentRef: 'SHP-2024-135',
      paymentTerms: 'Net 30',
      description: 'Port handling charges and berthing fees - 150,000 MT',
      contactPerson: 'Emma Davis',
      contactEmail: 'edavis@newcastleport.com.au',
      accountNumber: 'ACC-NP-2024',
      taxAmount: 2800.00,
      subtotal: 25200.00
    },
    {
      id: 'AP-2024-006',
      vendor: 'CoalTech Inspections',
      amount: 5400.00,
      currency: 'AUD',
      dueDate: '2025-01-22',
      issueDate: '2024-12-22',
      status: 'pending',
      category: 'Quality Inspection',
      shipmentRef: 'SHP-2024-140',
      paymentTerms: 'Net 30',
      description: 'Third-party quality inspection and certification services',
      contactPerson: 'David Kumar',
      contactEmail: 'dkumar@coaltechinspections.com',
      accountNumber: 'ACC-CT-2024',
      taxAmount: 540.00,
      subtotal: 4860.00
    },
    {
      id: 'AP-2024-007',
      vendor: 'Maritime Insurance Brokers',
      amount: 15800.00,
      currency: 'AUD',
      dueDate: '2025-01-25',
      issueDate: '2024-12-25',
      status: 'pending',
      category: 'Insurance',
      shipmentRef: 'SHP-2024-145',
      paymentTerms: 'Net 30',
      description: 'Marine cargo insurance - CIF value coverage',
      contactPerson: 'Lisa Anderson',
      contactEmail: 'landerson@maritimeinsurance.com.au',
      accountNumber: 'ACC-MI-2024',
      taxAmount: 1580.00,
      subtotal: 14220.00
    },
    {
      id: 'AP-2024-008',
      vendor: 'Environmental Compliance Services',
      amount: 3200.00,
      currency: 'AUD',
      dueDate: '2024-12-30',
      issueDate: '2024-11-30',
      status: 'paid',
      category: 'Compliance',
      shipmentRef: 'SHP-2024-105',
      paymentTerms: 'Net 30',
      description: 'Environmental compliance certification and documentation',
      paidDate: '2024-12-28',
      paidAmount: 3200.00,
      contactPerson: 'Rachel Green',
      contactEmail: 'rgreen@enviroservices.com.au',
      accountNumber: 'ACC-EC-2024',
      taxAmount: 320.00,
      subtotal: 2880.00
    },
    {
      id: 'AP-2025-001',
      vendor: 'Dalrymple Bay Terminal',
      amount: 32000.00,
      currency: 'AUD',
      dueDate: '2025-02-05',
      issueDate: '2025-01-05',
      status: 'pending',
      category: 'Terminal Charges',
      shipmentRef: 'SHP-2025-001',
      paymentTerms: 'Net 30',
      description: 'Terminal handling and storage charges - 200,000 MT',
      contactPerson: 'Mark Stevens',
      contactEmail: 'mstevens@dalrymplebay.com.au',
      accountNumber: 'ACC-DB-2025',
      taxAmount: 3200.00,
      subtotal: 28800.00
    },
    {
      id: 'AP-2025-002',
      vendor: 'Precise Weighbridge Services',
      amount: 2800.00,
      currency: 'AUD',
      dueDate: '2025-02-10',
      issueDate: '2025-01-10',
      status: 'pending',
      category: 'Weighing Services',
      shipmentRef: 'SHP-2025-008',
      paymentTerms: 'Net 30',
      description: 'Certified weighbridge services and weight verification',
      contactPerson: 'Tom Richardson',
      contactEmail: 'trichardson@preciseweigh.com.au',
      accountNumber: 'ACC-PW-2025',
      taxAmount: 280.00,
      subtotal: 2520.00
    },
    {
      id: 'AP-2024-009',
      vendor: 'SGS Australia',
      amount: 8500.00,
      currency: 'AUD',
      dueDate: '2024-12-20',
      issueDate: '2024-11-20',
      status: 'overdue',
      category: 'Testing & Certification',
      shipmentRef: 'SHP-2024-095',
      paymentTerms: 'Net 30',
      description: 'Independent coal quality testing and ISO certification',
      contactPerson: 'Jennifer Wang',
      contactEmail: 'jwang@sgs.com.au',
      accountNumber: 'ACC-SGS-2024',
      taxAmount: 850.00,
      subtotal: 7650.00
    },
    {
      id: 'AP-2024-010',
      vendor: 'AusShip Maritime Agents',
      amount: 6800.00,
      currency: 'AUD',
      dueDate: '2025-01-08',
      issueDate: '2024-12-08',
      status: 'pending',
      category: 'Agency Services',
      shipmentRef: 'SHP-2024-122',
      paymentTerms: 'Net 30',
      description: 'Ship agency and port coordination services',
      contactPerson: 'Peter Morrison',
      contactEmail: 'pmorrison@ausship.com.au',
      accountNumber: 'ACC-AS-2024',
      taxAmount: 680.00,
      subtotal: 6120.00
    }
  ]);

  // Summary statistics
  const totalOutstanding = invoices?.filter(inv => inv?.status !== 'paid')?.reduce((sum, inv) => sum + inv?.amount, 0);

  const overdueAmount = invoices?.filter(inv => inv?.status === 'overdue')?.reduce((sum, inv) => sum + inv?.amount, 0);

  const dueThisWeek = invoices?.filter(inv => {
      const dueDate = new Date(inv.dueDate);
      const today = new Date();
      const weekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
      return inv?.status === 'pending' && dueDate >= today && dueDate <= weekFromNow;
    })?.reduce((sum, inv) => sum + inv?.amount, 0);

  const filteredInvoices = invoices?.filter(invoice => {
    if (selectedStatus !== 'all' && invoice?.status !== selectedStatus) return false;
    if (searchTerm) {
      const searchLower = searchTerm?.toLowerCase();
      return (invoice?.id?.toLowerCase()?.includes(searchLower) ||
      invoice?.vendor?.toLowerCase()?.includes(searchLower) || invoice?.shipmentRef?.toLowerCase()?.includes(searchLower));
    }
    return true;
  });

  const getStatusBadge = (status) => {
    const styles = {
      pending: 'bg-yellow-100 text-yellow-800',
      overdue: 'bg-red-100 text-red-800',
      paid: 'bg-green-100 text-green-800',
    };
    return styles?.[status] || 'bg-gray-100 text-gray-800';
  };

  const handleAddInvoice = () => {
    setShowAddInvoiceModal(true);
  };

  const handleSaveInvoice = (invoiceData) => {
    console.log('Saving invoice:', invoiceData);
    // TODO: Implement actual save with Supabase
    alert('✅ Invoice added successfully!');
    setShowAddInvoiceModal(false);
  };

  const handleApproveInvoice = (invoiceId) => {
    console.log('Approving invoice:', invoiceId);
    // TODO: Implement approval
    alert('✅ Invoice approved for payment!');
  };

  const handleRejectInvoice = (invoiceId) => {
    const reason = prompt('Please provide rejection reason:');
    if (reason) {
      console.log('Rejecting invoice:', invoiceId, reason);
      // TODO: Implement rejection
      alert('✅ Invoice rejected!');
    }
  };

  const handleSchedulePayment = (invoiceId, date) => {
    console.log('Scheduling payment:', invoiceId, date);
    // TODO: Implement payment scheduling
    alert(`✅ Payment scheduled for ${date}`);
  };

  const handleMarkAsPaid = (invoiceId) => {
    console.log('Marking as paid:', invoiceId);
    // TODO: Implement payment recording
    alert('✅ Invoice marked as paid!');
  };

  const handleExport = () => {
    alert(`✅ Exporting ${invoices?.length} invoices...`);
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        {/* Mobile-optimized header */}
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col gap-3 sm:gap-4">
            {/* Title and actions - responsive */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                  Accounts Payable
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                  Vendor invoice and payment tracking system
                </p>
              </div>
              
              {/* Action buttons */}
              <div className="flex items-center gap-2 flex-wrap">
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={handleAddInvoice}
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto flex-1 sm:flex-initial"
                >
                  Add Invoice
                </Button>
                <Button
                  variant="outline"
                  iconName="Download"
                  iconPosition="left"
                  onClick={handleExport}
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Export</span>
                  <Icon name="Download" size={16} className="sm:hidden" />
                </Button>
              </div>
            </div>

            {/* Filters and search - mobile scrollable */}
            <div className="flex items-center gap-2 overflow-x-auto pb-2 -mx-3 px-3 sm:mx-0 sm:px-0 no-scrollbar">
              {/* Add your filter components here with responsive classes */}
            </div>
          </div>
        </header>

        {/* Main content - responsive grid */}
        <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
          {/* Search and filters */}
          <div className="mb-4 flex flex-col sm:flex-row gap-3">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Search by ID, Vendor, or Shipment Ref..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e?.target?.value)}
              className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="overdue">Overdue</option>
              <option value="paid">Paid</option>
            </select>
          </div>

          {/* Summary Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
              <p className="text-sm text-blue-700 font-medium mb-1">Total Outstanding</p>
              <p className="text-2xl font-bold text-blue-900">
                ${totalOutstanding?.toLocaleString()} AUD
              </p>
            </div>
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-4 border border-red-200">
              <p className="text-sm text-red-700 font-medium mb-1">Overdue</p>
              <p className="text-2xl font-bold text-red-900">
                ${overdueAmount?.toLocaleString()} AUD
              </p>
            </div>
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg p-4 border border-yellow-200">
              <p className="text-sm text-yellow-700 font-medium mb-1">Due This Week</p>
              <p className="text-2xl font-bold text-yellow-900">
                ${dueThisWeek?.toLocaleString()} AUD
              </p>
            </div>
          </div>

          {/* Data Table */}
          <div className="overflow-x-auto -mx-3 sm:mx-0 bg-card rounded-lg border border-border">
            <table className="w-full min-w-[800px]">
              <thead className="bg-muted/50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Invoice ID
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Vendor
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Category
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Shipment Ref
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Amount (AUD)
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Due Date
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {filteredInvoices?.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="px-4 py-8 text-center text-muted-foreground">
                      No invoices found
                    </td>
                  </tr>
                ) : (
                  filteredInvoices?.map((invoice) => (
                    <tr key={invoice?.id} className="hover:bg-muted/30 transition-colors">
                      <td className="px-4 py-3 text-sm font-medium text-foreground">
                        {invoice?.id}
                      </td>
                      <td className="px-4 py-3 text-sm text-foreground">
                        <div>
                          <p className="font-medium">{invoice?.vendor}</p>
                          <p className="text-xs text-muted-foreground">{invoice?.contactPerson}</p>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-foreground">
                        {invoice?.category}
                      </td>
                      <td className="px-4 py-3 text-sm text-muted-foreground">
                        {invoice?.shipmentRef}
                      </td>
                      <td className="px-4 py-3 text-sm font-semibold text-foreground">
                        ${invoice?.amount?.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-sm text-foreground">
                        {new Date(invoice?.dueDate)?.toLocaleDateString()}
                      </td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(invoice?.status)}`}>
                          {invoice?.status?.charAt(0)?.toUpperCase() + invoice?.status?.slice(1)}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <div className="flex items-center gap-2">
                          {invoice?.status === 'pending' && (
                            <>
                              <button
                                onClick={() => handleApproveInvoice(invoice?.id)}
                                className="text-green-600 hover:text-green-800 transition-colors"
                                title="Approve"
                              >
                                <Icon name="CheckCircle" size={18} />
                              </button>
                              <button
                                onClick={() => handleRejectInvoice(invoice?.id)}
                                className="text-red-600 hover:text-red-800 transition-colors"
                                title="Reject"
                              >
                                <Icon name="XCircle" size={18} />
                              </button>
                            </>
                          )}
                          {invoice?.status === 'overdue' && (
                            <button
                              onClick={() => handleSchedulePayment(invoice?.id, new Date()?.toISOString()?.split('T')?.[0])}
                              className="text-orange-600 hover:text-orange-800 transition-colors"
                              title="Schedule Payment"
                            >
                              <Icon name="Calendar" size={18} />
                            </button>
                          )}
                          <button
                            onClick={() => handleMarkAsPaid(invoice?.id)}
                            className="text-blue-600 hover:text-blue-800 transition-colors"
                            title="Mark as Paid"
                          >
                            <Icon name="DollarSign" size={18} />
                          </button>
                          <button
                            onClick={() => console.log('View details:', invoice?.id)}
                            className="text-gray-600 hover:text-gray-800 transition-colors"
                            title="View Details"
                          >
                            <Icon name="Eye" size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountsPayable;